// 日期工具函数集合

/**
 * 获取当前时间的 UTC+8 ISO 格式字符串
 * @returns {String} UTC+8 时间的 ISO 格式字符串，如 "2024-01-14T15:30:00.000+08:00"（若后端字段为 LocalDateTime，调用方需 .replace('+08:00', '') 去掉时区偏移）
 */
export function getUTC8ISOString() {
  const now = new Date()
  const offset = 8 * 60 // UTC+8 偏移量（分钟）
  const utc8Time = new Date(now.getTime() + (offset + now.getTimezoneOffset()) * 60 * 1000)
  
  const year = utc8Time.getFullYear()
  const month = (utc8Time.getMonth() + 1).toString().padStart(2, '0')
  const day = utc8Time.getDate().toString().padStart(2, '0')
  const hour = utc8Time.getHours().toString().padStart(2, '0')
  const minute = utc8Time.getMinutes().toString().padStart(2, '0')
  const second = utc8Time.getSeconds().toString().padStart(2, '0')
  const ms = utc8Time.getMilliseconds().toString().padStart(3, '0')
  
  return `${year}-${month}-${day}T${hour}:${minute}:${second}.${ms}+08:00`
}

/**
 * 格式化日期时间
 * @param {Date|Array|String} dateTime - 日期时间，支持Date对象、字符串或后端返回的数组格式[year,month,day,hour,minute,second,nano]
 * @returns {String} 格式化后的日期字符串，格式为"YYYY-MM-DD HH:mm:ss"
 */
export function formatDate(dateTime) {
  if (!dateTime) return '-';
  
  try {
    let year, month, day, hour, minute, second;
    
    // 处理后端返回的日期数组格式 [year, month, day, hour, minute, second, nano]
    if (Array.isArray(dateTime) && dateTime.length >= 6) {
      year = dateTime[0];
      month = dateTime[1].toString().padStart(2, '0');
      day = dateTime[2].toString().padStart(2, '0');
      hour = dateTime[3].toString().padStart(2, '0');
      minute = dateTime[4].toString().padStart(2, '0');
      second = dateTime[5].toString().padStart(2, '0');
      
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    } else {
      // 处理字符串或Date对象
      const dt = new Date(dateTime);
      if (isNaN(dt.getTime())) {
        return String(dateTime);
      }
      
      year = dt.getFullYear();
      month = (dt.getMonth() + 1).toString().padStart(2, '0');
      day = dt.getDate().toString().padStart(2, '0');
      hour = dt.getHours().toString().padStart(2, '0');
      minute = dt.getMinutes().toString().padStart(2, '0');
      second = dt.getSeconds().toString().padStart(2, '0');
      
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    }
  } catch (e) {
    console.error('日期格式化错误:', e, dateTime);
    return String(dateTime); // 出错时返回原始字符串的字符串表示
  }
}

/**
 * 格式化日期（不含时间）
 * @param {Date|Array|String} date - 日期，支持Date对象、字符串或后端返回的数组格式[year,month,day,...]
 * @returns {String} 格式化后的日期字符串，格式为"YYYY-MM-DD"
 */
export function formatDateOnly(date) {
  if (!date) return '-';
  
  try {
    let year, month, day;
    
    // 处理后端返回的日期数组格式 [year, month, day, ...]
    if (Array.isArray(date) && date.length >= 3) {
      year = date[0];
      month = date[1].toString().padStart(2, '0');
      day = date[2].toString().padStart(2, '0');
      
      return `${year}-${month}-${day}`;
    } else {
      // 处理字符串或Date对象
      const dt = new Date(date);
      if (isNaN(dt.getTime())) {
        return String(date);
      }
      
      year = dt.getFullYear();
      month = (dt.getMonth() + 1).toString().padStart(2, '0');
      day = dt.getDate().toString().padStart(2, '0');
      
      return `${year}-${month}-${day}`;
    }
  } catch (e) {
    console.error('日期格式化错误:', e, date);
    return String(date);
  }
} 